
export default (object, properties) => {
  let arr = {...properties}
  let obj = {}
  for (const prop of properties) {
    obj[`${object}.${prop}`] = function()  {
      this.touched[prop] = true
    }
  }
  return obj
}



// WEBPACK FOOTER //
// ./src/utils/watchTouchedProperties.js